import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=d86a5fa2&lang=pug"
import script from "./Ideas.vue?vue&type=script&lang=js"
export * from "./Ideas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports